import 'echarts/lib/chart/candlestick';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { isArray, merge } from 'lodash';

import ChartService from './ChartService';
import { chartConfig } from '../charts';

export default class ChartKaplanMeierService extends ChartService {
  buildChartData(visualization) {
    const symbols = visualization.symbols || Object.values(chartConfig.symbols);

    const tooltipFnc = item => {
      var value = item.value;
      if (isArray(value)) {
        value = value[2] - value[1];
      }
      return `${item.seriesName}: ${Math.round(value * 1000) / 1000}`;
    };
    const tooltipFncStdDev = item => {
      var value = item.value[2] - item.value[1];
     // return `${item.seriesName}: ${Math.round(value * 1000) / 1000}`;
     return `${item.seriesName}: ${value.toFixed(5)}`;
    };

    const options = {
      grid: {
        bottom: visualization.dataZoom ? '10%' : '6%',
        containLabel: true,
        left: '6%',
        right: '6%',
        top: '10%',
      },
      tooltip: {
        trigger: 'axis',
        formatter: (items) => {
          var groups = items.takeInGroups(2)

          let str = `${items[0].name} <br />`;

          str += groups
            .map((items, ind) => {
              var name = visualization.data[ind].name;
              return `
                <svg viewBox="0 0 12 12" height="12" width="12" style="margin: 0 5px 0 0; position: relative; top: 1px;">
                  <path fill="${visualization.data[ind].color}" d="M0 0h12v12H0z" />
                </svg>
                ${name}<br />
                ${tooltipFnc(items[0])}; ${tooltipFncStdDev(items[1])}
                `;
            })
            .join('<br />');

          return str;
        },
      },
      xAxis: {
        axisLabel: {        
          fontSize: 13,
          margin:10,
        },
        axisLine: {
          lineStyle: {
            color: '#767676',
          },
        },
        axisTick: {
          lineStyle: {
            color: '#767676',
          },
        },
        name: 'Months',
        nameGap: 30,
        nameLocation: 'center',
        nameTextStyle: {
          fontWeight: 'bold',
          fontSize: 13,
        },
        boundaryGap: false,
        type: 'category',
        data: visualization.data.sortBy(f => f.data.length).last()?.data.map(f => f[0]),
      },
      yAxis: {
        axisLabel: {
          fontSize: 13,
          margin: 30,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        name: 'Persistence',
        nameGap: 70,
        nameLocation: 'center',
        nameTextStyle: {
          fontWeight: 'bold',
          fontSize: 13,
        },
        type: 'value'
      },
      series: visualization.data.flatMap(result => {
        return [
          {
            name: 'S(t)',
            type: 'line',
            step: 'end',
            data: result.data.map(f => f[1]),
            color: result.color,
            // symbolSize: 10,
          },
          {
            name: 'Std',
            type: 'candlestick',
            data: result.data.map(f => {
              var middle = f[1];
              var half = f[2] / 2;
              return [middle - half, middle + half, middle - half, middle + half,]
            }),
            barWidth: 4,
          },
        ]
      }),
    };
    // return options;
    return merge(this.defaultChartOptions, {
      ...options,
      forceRedraw: visualization.forceRedraw,
    });
  }
}
